export enum ModuleTypeDescriptionEnum {
  Regulatory = 'regulatory',
  Python = 'python'
}
